const apiBaseState = () => {
    return {
        data: null,
        loading: false,
        errorMessage: null,
        errorStatus: null,
        percentage: 0,
        streaming: null
    };
};

export default apiBaseState;
